"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDropzone = _interopRequireDefault(require("react-dropzone"));

var _ButtonBase = _interopRequireDefault(require("@material-ui/core/ButtonBase"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const UploadButton = ({
  classes,
  className,
  accept,
  multiple,
  onUpload,
  children
}) => {
  return _react.default.createElement(_reactDropzone.default, {
    multiple: multiple,
    accept: accept,
    onDrop: event => onUpload(event)
  }, ({
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject
  }) => _react.default.createElement(_ButtonBase.default, _extends({}, getRootProps(), {
    classes: classes,
    className: className
  }), _react.default.createElement("input", getInputProps()), children));
};

var _default = UploadButton;
exports.default = _default;
module.exports = exports.default;